<template>
	<div>
		<buttonlist @help="help" @add="add" @search="search" @reflash="reflash"  @exps="exps" ref="SetBtn"></buttonlist>
		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini" @click="canuse" :disabled="!btn.canuse">{{$t('getapi[2497]')}}</el-button>
					<el-button type="primary" size="mini" @click="cannotuse" :disabled="!btn.cannotuse">{{$t('getapi[2498]')}}</el-button>
					<el-button type="primary" size="mini" @click="collsoPrint">{{$t('getapi[940]')}}</el-button>
				</div>
			</div>
		</el-card>
		<!-- <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
			<el-tab-pane :label="$t('getapi[945]')" name="0"> -->
				<el-table
					id="xpane-0"
					:data="dataSet"
					v-loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					@row-click="selectRow"
					@selection-change="handleSelectionChange"
					:height="tableHeight"
					header-row-class-name="headerclass"
					style="width: 100%; margin-top:0px"
					:header-cell-style="$limits.headerClass"
					ref="singleTable"
				>
					<el-table-column type="selection" v-if="true"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargoPosition_code" :label="$t('getapi[1842]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="inventory_code" :label="$t('getapi[1958]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Area_code" :label="$t('getapi[1959]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Sheet_code" :label="$t('getapi[1960]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Layer_code" :label="$t('getapi[1961]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="coordinate" :label="$t('getapi[1962]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargoPositionType" :label="$t('getapi[867]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="groupName" :label="$t('getapi[1108]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
					<el-table-column prop="enable_flag" :label="$t('getapi[552]')">
						<template scope="scope">
							<span>{{ scope.row.enable_flag | lanchange}}</span>
						</template>
					</el-table-column>
					<el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
					<template slot-scope="scope">
						<el-button @click.native.prevent="editInfo(scope)" type="text" size="mini" :disabled="!btn.edit">{{ $t('getapi[34]') }}</el-button>
						<el-popconfirm
							:confirmButtonText="$t('getapi[6109]')"
							:cancelButtonText="$t('getapi[6]')"
							icon="el-icon-info"
							iconColor="red"
							:title="$t('getapi[637]')"
						>
						</el-popconfirm>
					</template>
			</el-table-column>
				</el-table>
			<!-- </el-tab-pane> -->
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[50, 100, 200, 300]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SysCargopositionViewInfo" ref="ser" @getser="serclick"></serce>

		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[6429]')" width="50%">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="120px" label-position="left" size="small">
						<el-row>
							<el-col :span="8">
								<el-form-item :label="$t('getapi[1842]')">
									<el-input v-model="formInline.cargoposition_code" :placeholder="$t('getapi[1842]')" :readonly="isEdit == true" :class="{'readO':isEdit == true}"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('getapi[1958]')"><el-input v-model="formInline.inventory_code" :placeholder="$t('getapi[1958]')"></el-input></el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('getapi[1959]')"><el-input v-model="formInline.area_code" :placeholder="$t('getapi[1959]')"></el-input></el-form-item>
							</el-col>
						</el-row>

						<el-row>
							<el-col :span="8">
								<el-form-item :label="$t('getapi[1960]')"><el-input v-model="formInline.sheet_code" :placeholder="$t('getapi[1960]')"></el-input></el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('getapi[1961]')"><el-input v-model="formInline.layer_code" :placeholder="$t('getapi[1961]')"></el-input></el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('getapi[1962]')"><el-input v-model="formInline.coordinate" :placeholder="$t('getapi[1962]')"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<!-- <el-form-item :label="$t('getapi[867]')"><el-input v-model="formInline.cargopositiontype_id" :placeholder="$t('getapi[867]')"></el-input></el-form-item> -->
								<el-form-item :label="$t('getapi[867]')">
									<el-select v-model="formInline.cargopositiontype_id" :placeholder="$t('getapi[867]')" :disabled="isEdit">
										<el-option v-for="items in CargoPositionTypeList" :key="items.Code" :label="items.Name" :value="items.Code"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<!-- <el-form-item :label="$t('getapi[1108]')"><el-input v-model="formInline.cargopositiongroup_id" :placeholder="$t('getapi[1108]')"></el-input></el-form-item> -->
								<el-form-item :label="$t('getapi[1108]')">
									<el-select v-model="formInline.cargopositiongroup_id" :placeholder="$t('getapi[1108]')">
										<el-option v-for="items in CargoGroupList" :key="items.Code" :label="items.Name" :value="items.Code"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item :label="$t('getapi[143]')"><el-input v-model="formInline.remark" :placeholder="$t('getapi[143]')"></el-input></el-form-item>
							</el-col>
						</el-row>

						<!-- <el-form-item><el-button type="primary" @click="onSubmit">查询</el-button></el-form-item> -->
					</el-form>
				</el-col>
			</el-row>

			<span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="save">{{$t('getapi[937]')}}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="showCollsoPrint" :title="$t('getapi[34]')" width="300px" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div>
				<table>
					<tr>
						<td>{{$t('getapi[12749]')}}</td>
						<td>
							<el-select v-model="printerid" class="select" @change="changePrinter">
								<el-option v-for="item in printerArr" :key="item.id" :label="item.name"
										   :value="item.id"></el-option>
							</el-select>
						</td>
						<td><el-button type="primary" @click="editPrinter" size="mini">{{ $t('getapi[34]') }}</el-button></td>
					</tr>
					<tr>
						<td>{{$t('getapi[12868]')}}</td>
						<td>
							<el-input v-model="copies" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
						</td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showCollsoPrint = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="mini" type="primary" @click="confirmCollsoPrint">{{$t('getapi[1146]')}}{{$t('getapi[940]')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="showPrinter" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div>
				<div>
					<el-button type="primary" size="mini" @click="addPrinter">{{
						$t('getapi[878]') }}
					</el-button>
				</div>
				<el-table
						:data="printerArr"
						:highlight-current-row="true"
						:height="300"
						header-row-class-name="headerclass"
						border
						size="mini"
						style="width: 100%; margin-top:2px"
				>
					<el-table-column show-overflow-tooltip prop="ip" :label="$t('getapi[12750]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[12751]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[12752]')"></el-table-column>
					<el-table-column fixed="right" :label="$t('getapi[6048]')" width="150">
						<template slot-scope="scope">
							<el-button @click.native.prevent="editPrinter_(scope)" type="text" size="small">{{
								$t('getapi[34]') }}
							</el-button>
							<el-popconfirm
									:confirmButtonText="$t('getapi[6109]')"
									:cancelButtonText="$t('getapi[6]')"
									icon="el-icon-info"
									iconColor="red"
									:title="$t('getapi[637]')"
									@onConfirm="delPrinter_(scope)"
							>
								<el-button slot="reference" type="text" size="small">{{ $t('getapi[40]')
									}}
								</el-button>
							</el-popconfirm>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-divider></el-divider>

			<span slot="footer" class="dialog-footer">
				<el-button  @click="showPrinter = false" size="mini">{{ $t('getapi[6]') }}</el-button>
			</span>
		</el-dialog>

		<el-dialog v-dialogDrag :visible.sync="showEditPrinter" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">

			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[12750]')}}</td>
						<td><el-input v-model="printerDetail.ip" type="text" size="mini"></el-input></td>
						<td>{{$t('getapi[12751]')}}</td>
						<td><el-input v-model="printerDetail.model" type="text" size="mini"></el-input></td>
					</tr>
					<tr>
						<td>{{$t('getapi[12752]')}}</td>
						<td><el-input v-model="printerDetail.name" type="text" size="mini"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="showEditPrinter = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="mini" type="primary" @click="savePrinter">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'CargoManager',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-180
        }
    },
	data() {
		return {
			formInline: {
				cargoposition_code: '',
				old_cargoposition_code: '',
				inventory_code: '',
				area_code: '',
				sheet_code: '',
				layer_code: '',
				coordinate: '',
				remark: '',
				cargopositiontype_id: 0,
				cargopositiongroup_id: 0,
				enable_flag: 1,
				groupname:'',
				isadd: 0
			},
			selectIDData: '',
			CargoPositionTypeList: [], //货位类型名称
			CargoGroupList: [], //货位组名
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('CargoManager'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			isEdit: true, // 是否新增操作
			nowPOCode: 0, // 当前单号
			btn: {
				cannotuse: false,
				canuse: false,
                edit: false,
			},
            scrollTop:0,
            showCollsoPrint:false,
            printerid:'',
            selectPrinterDetail:{
                id:'',
                ip:'',
                model:'',
                name:''
            },
            printerArr:[],
            copies:1,
            showPrinter:false,
            showEditPrinter:false,
            printerDetail:{
                id:'',
                ip:'',
                model:'',
                name:''
            },
            printData:[],
            addoreditprint: 1,//1新增2编辑
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.$http.urlpost('Basic/GetCargoPositionTypeList', {}, function(res) {
			console.log(res);
			if (res.Success == 1) {
				that.CargoPositionTypeList = res.DataContent;
				that.formInline.cargopositiontype_id = 1;
			}
		});
		that.$http.urlpost('Basic/GetCargoGroupList', {}, function(res) {
			console.log(res);
			if (res.Success == 1) {
				that.CargoGroupList = res.DataContent;
				that.formInline.cargopositiongroup_id = 1;
			}
		});
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[989]"),this.$t("getapi[15]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.btn.edit = false
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 90, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 90, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
                    that.btn.edit = true
					that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
					break;
				case 2:
                    that.btn.edit = true
					that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
					break;
				case -3:
                    that.btn.edit = true
					that.$refs.SetBtn.SetButtonEnable('create,search,refresh');
					break;
				case 3:
                    that.btn.edit = true
					that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
					break;
				default:
					break;
			}
			that.btnauthority();
		},
		btnauthority() {
			let that = this;
			if (that.$limits.authority('plv3', 90, 1) >= 1) {
				that.btn.cannotuse = true;
				that.btn.canuse = true;
			} else {
				that.btn.cannotuse = false;
				that.btn.canuse = false;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('CargoManager',val)
			this.intidata();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.intidata();
			this.authority();
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].cargoPosition_code + ',';
			}
			console.log(that.selectIDData);
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'SysCargopositionViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.pageIndex = 1;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.intidata();
		},

		// 数据一览
		intidata() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				Param: datac
			};
			console.log(data);
			that.$http.urlpost('/Inv/Manager/CargoPositionView', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(jsd) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			this.editvisi = true;
			this.formInline= {
				cargoposition_code: jsd.row.cargoPosition_code,
				old_cargoposition_code: jsd.row.cargoPosition_code,
				inventory_code: jsd.row.inventory_code,
				area_code: jsd.row.Area_code,
				sheet_code: jsd.row.Sheet_code,
				layer_code: jsd.row.Layer_code,
				coordinate: jsd.row.coordinate,
				remark: jsd.row.remark,
				cargopositiontype_id: jsd.row.cargoPositionType_ID,
				groupname:jsd.row.groupName,
				cargopositiongroup_id: jsd.row.cargoPositionGroup_ID,
				enable_flag: jsd.row.enable_flag,
				isadd: 1
			}
		},
		// 新增
		add() {
			let that = this;
			let datetime = (
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				new Date().getHours() +
				':' +
				new Date().getMinutes() +
				':' +
				new Date().getSeconds()
			).toString();
			that.isEdit = false;
			that.isShowEdit = true;
			this.formInline= {
				cargoposition_code: '',
				old_cargoposition_code: '',
				inventory_code: '',
				area_code: '',
				sheet_code: '',
				layer_code: '',
				coordinate: '',
				remark: '',
				cargopositiontype_id: 1,
				cargopositiongroup_id: 0,
				enable_flag: 1,
				groupname:'',
				isadd: 2
			}
			
		},
		// 刷新
		reflash() {
			let that = this;
			that.intidata();
		},
		canuse() {
			let that = this;
			if(that.selectIDData==""){
				that.$message.warning(that.$t('getapi[4861]'));//"请选择货位！"
				return;
			}
			let parm = {
				ids: that.selectIDData
			};
			that.$http.urlpost('/Inv/Manager/CargoPositioExecuteTrue', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.intidata();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		cannotuse() {
			let that = this;
			if(that.selectIDData==""){
				that.$message.warning(that.$t('getapi[4861]'));//"请选择货位！"
				return;
			}
			let parm = {
				ids: that.selectIDData
			};
			that.$http.urlpost('/Inv/Manager/CargoPositioExecuteFalse', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.intidata();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac,
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[1957]')
			};
			that.$http.urlpost('/Inv/Manager/CargoPositionExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
		// 保存
		save() {
			let that = this;
			let parm = that.formInline;
			parm.LangType = that.$processdata.getLang()
			that.$http.urlpost('/Inv/Manager/SaveCargoPosition', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {										
					that.intidata();
					that.$message.success(that.$t('getapi[3153]'));//'保存成功'
					that.isShowEdit = false;
				}
				that.loading = false;
			});
		},

		editInfo1() {},
		editInfo2() {},
		editInfo3() {},
		selectRow(row) {
			let that = this;
			that.nowPOCode = row.Order_No;
		},
		//打印
        collsoPrint(){
            let that = this
            let parm = {}
            that.$http.urlpost('/Print/GetPrinter', parm, function (res) {
                if (res.Success == 1) {
                    if(res.DataContent){
                        that.printerArr = res.DataContent
                        that.printerid = window.localStorage.getItem('printerid_cargo') == undefined?'':parseInt(window.localStorage.getItem('printerid_cargo'))
                        for(let i=0;i<that.printerArr.length;i++){
                            if(that.printerid == that.printerArr[i].id){
                                that.selectPrinterDetail = that.printerArr[i]
                                break
                            }
                        }
                    }
                    let datac = [];
                    for (let i = 0; i < that.queryData.length; i++) {
                        datac.push({
                            query_Condition: that.queryData[i].query_Condition,
                            query_field_type: that.queryData[i].Query_Field_Type,
                            query_field_name: that.queryData[i].Query_Field_Name,
                            query_sort: that.queryData[i].query_sort,
                            row_sign: that.queryData[i].row_sign
                        });
                    }
                    let parm1 = {
                        PageIndex: 1,
                        PageSize: 100000,
                        Param: datac
                    }
                    that.$http.urlpost('/Print/CargoPrint', parm1, function (res) {
                        if(res.Success == 1){
                            that.printData = res.DataContent
							that.copies = 1
                            that.showCollsoPrint = true
                        }
                    })
                }
            });
        },
        changePrinter(val){
            let that = this
            console.log(val)
            for(let i=0;i<that.printerArr.length;i++){
                if(val == that.printerArr[i].id){
                    that.selectPrinterDetail = that.printerArr[i]
                }
            }
        },
        getPrinterArr(){
            let that = this
            that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                if (res.Success == 1) {
                    that.printerArr = res.DataContent
                }
            });
        },
        confirmCollsoPrint(){
            let  that = this
            that.printerid = window.localStorage.setItem('printerid_cargo', that.selectPrinterDetail.id)
            let RequestData = { 'user': that.user,'data':that.printData,'printer':that.selectPrinterDetail,'copies':that.copies};
            $.ajax({
                url: that.selectPrinterDetail.ip,
                type: 'post',
                contentType: 'application/json',
                data: JSON.stringify(RequestData),
                success: function (res) {
                    that.showCollsoPrint = false
                },
                error: function (xhr, errorType, error) {

                }
            });
        },
        editPrinter(){
            let that = this
            that.showPrinter = true
        },
        addPrinter(){
            let that = this
            that.showEditPrinter = true
            that.addoreditprint = 1
            that.printerDetail = {
                id: '',
                ip: '',
                model: '',
                name: ''
            };
        },
        editPrinter_(row) {
            let that = this
            that.showEditPrinter = true;
            that.addoreditprint = 2
            that.printerDetail = {
                id: row.row.id,
                ip: row.row.ip,
                model: row.row.model,
                name: row.row.name
            };
        },
        delPrinter_(row){
            let that = this
            let parm = {
                id: row.row.id,
                ip: row.row.ip,
                model: row.row.model,
                name: row.row.name
            }
            that.$http.urlpost('/Print/DeletePrinter', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.$http.urlpost('/Print/GetPrinter', {}, function (res) {
                        if (res.Success == 1) {
                            that.printerArr = res.DataContent
                        }
                    });
                }
            });
        },
        savePrinter(){
            let that = this
            let parm = that.printerDetail
            if(that.addoreditprint == 1){
                that.$http.urlpost('/Print/InsertPrinter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.showEditPrinter = false
                        that.getPrinterArr()
                    }
                });
            } else if(that.addoreditprint == 2){
                that.$http.urlpost('/Print/UpdatePrinter', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.showEditPrinter = false
                        that.getPrinterArr()
                    }
                });
            }
        },
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
